<template>
    <div class="filter-group">
        <div
            class="filter-group-header"
            v-b-toggle="`${title}-filter-options`">
            <h5 class="title btn-after-chevron-up">{{ title }}</h5>
        </div>

        <b-collapse
            visible
            :id="`${title}-filter-options`">
            <div class="options">
                <b-form-checkbox-group
                    class="apprentice-checkbox"
                    :options="options.slice(0, 5)"
                    stacked
                    @change="updateFilter"
                    :checked="selected">
                </b-form-checkbox-group>
            </div>

            <div
                class="options-continued"
                v-if="options.length > 5">
                <p
                    class="show-more btn-link-type"
                    v-b-toggle="`${title}-load-more-options`">
                    {{ $t('modules.show_more') }}
                </p>

                <b-collapse
                    class="load-more-options"
                    :id="`${title}-load-more-options`">
                    <b-form-checkbox-group
                        class="apprentice-checkbox"
                        :options="options.slice(5)"
                        stacked
                        @change="updateFilter"
                        :checked="selected">
                    </b-form-checkbox-group>

                    <p
                        class="show-less btn-link-type"
                        v-b-toggle="`${title}-load-more-options`">
                        {{ $t('modules.show_less') }}
                    </p>
                </b-collapse>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'design-2021-module-checkbox-filter-component',
    props: {
        title: String,
        options: Array,
        selectedIn: Array,
    },

    data() {
        return {
            visible: false,
            selected: this.selectedIn,
        };
    },

    methods: {
        updateFilter(checked) {
            this.$emit('update-filter', checked, this.title.toLowerCase());
        },
    },

    watch: {
        selectedIn: function (value) {
            this.selected = value;
        },
    },
};
</script>

<style scoped lang="scss">
.filter-group ::v-deep {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .apprentice-checkbox {
        input[type='checkbox']:checked ~ .custom-control-label span,
        &:hover span {
            font-weight: $font-weight-normal;
        }

        .custom-checkbox {
            input[type='checkbox']:checked ~ .custom-control-label span {
                font-weight: $font-weight-bold;
            }

            &:hover {
                span {
                    font-weight: $font-weight-bold;
                }
            }
        }
    }
}

.filter-group-header {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
    border-bottom: 1px solid $border-color;

    .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: $font-weight-bold;

        &:after {
            font-size: $default-font-size;
            transform-origin: center;
            transition: transform 0.4s ease;
        }
    }

    &.collapsed {
        .title:after {
            transform: rotate(180deg);
        }
    }
}

.show-more,
.show-less {
    display: flex;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'eight');
    transition: all 0.5s ease;
    margin-bottom: 0;
}

.show-more {
    &.not-collapsed {
        display: none;
    }
}

.show-less {
    &.collapsed {
        display: none;
    }

    &.not-collapsed {
        display: flex;
    }
}
</style>
